import { Modal } from './src/Modal';
import { Header } from './src/Header';
import { Footer } from './src/Footer';
import { Controls } from './src/Controls';

Modal.Header = Header;
Modal.Footer = Footer;
Modal.Controls = Controls;

export { Modal };
